var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"app-content content"},[_c('div',{staticClass:"content-overlay"}),_vm._v(" "),_c('div',{staticClass:"content-wrapper"},[_c('flash-messages'),_vm._v(" "),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }